<template>
  <div>
    <tracking-table class="mt-3" :data="data" :tableLoading="loading" />
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

import { getTrackingBookings } from "@/constants/lineas";


import TrackingTable from "@/components/tablas/tracking/TrackingTable.vue";

export default {
  data() {
    return {
      data: [],
      loading: false
    };
  },
  computed: {
    ...mapState(["token"]),
    ...mapState("lineas", [
      "dataDatatableTrackingBookings",
      "dataDatatableTrackingBookingsFiltered"
    ])
  },
  components: {
    TrackingTable
  },
  methods: {
    // Acciones de Vuex
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoading",
      "ActionSetLoadingTable"
    ]),
    ...mapActions("lineas", [
      "actionSetDataDatatableTrackingBookings",
      "actionSetListaClientes",
      "actionSetLista_puertos",
      "actionSetDataSemanas",
      "actionSetDataListaNaviera",
      "actionSetLista_anios",
      "actionSetDataListaNave"
    ]),

    actualizarURL() {

      let me = this;

      me.AccionCambiar(this.$route.path);

    },

    async getTrackingBookings() {

      this.loading = true;

      let tracking_bookings = await getTrackingBookings();

      this.actionSetDataDatatableTrackingBookings(tracking_bookings.data);

      this.actionSetListaClientes(tracking_bookings.customers_list);

      this.actionSetDataListaNaviera(tracking_bookings.carriers_list);

      this.actionSetDataSemanas(tracking_bookings.weeks_list);

      this.actionSetLista_puertos(tracking_bookings.ports_list);

      this.actionSetLista_anios(tracking_bookings.years_list);

      this.actionSetDataListaNave(tracking_bookings.ships_list);

      this.loading = false;

    }
  },

  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();

    this.getTrackingBookings();

  },

  watch: {

    dataDatatableTrackingBookings: function(_new) {

      if (_new) {

        this.data = _new;

      }

    },

    dataDatatableTrackingBookingsFiltered: function(_new) {

      if (_new === false) {

        this.getTrackingBookings();

      } else {

        this.data = _new;
      }

    }

  }

};
</script>
<style></style>
